<template>
  <div>
    <q-tree
      :ref="getRef"
      class="filter-tree"
      :data="items"
      :props="defaultProps"
      default-expand-all
      :expand-on-click-node="false"
      :filter-node-method="filterNode"
      @node-click="handleNodeClick"
    />
  </div>
</template>

<script>
  export default {
    name: "QParameterSelector",

    props: {
      value: {
        required: true
      },

      plugin: {required: true, type: String},
      delegate: {required: true, type: String},
      fetchData: {required: true, type: Object},
      resultKey: {required: true, type: String},


      disabled: {type: Boolean, default: false},
      children: {required: true, type: String},
      label: {type: String, required: true},
      valueField: {required: true, type: String},
      propertyKey: {required: true, type: String},

    },

    data() {
      return {
        value_: {},
        items: [],

        filterText: '',
        currentModel: {},
        defaultProps: {
          children: this.children,
          label: this.label
        }
      }
    },

    computed: {
      getRef() {
        return 'all_' + this.propertyKey;
      }
    },

    watch: {
      value_() {
        this.$emit('input', this.value_);
      },
      value() {
        this.value_ = this.value;
      },

      filterText(val) {
        this.$refs[this.getRef].filter(val);
      }
    },
    created() {
      this.value_ = this.value;
    },

    mounted() {
      this.fetchItems();
    },

    methods: {
      fetchItems() {
        this.$delegate(
          this.plugin,
          this.delegate,
          this.fetchData
        ).then((res) => {
          this.items = res.result[this.resultKey];
        }).catch(() => {
        });
      },

      filterNode(value, data) {
        if (!value) return true;
        return data[this.label].indexOf(value) !== -1;
      },
      handleNodeClick(data) {
        this.value_ = data[this.valueField];
      }
    }

  }
</script>

<style scoped>

</style>